export const SPAIN_COUNTRY_ID = 28
export const MX_COUNTRY_ID = 42


// WEBPACK FOOTER //
// ./src/constants/db/countries.js